<script lang="ts">
import Vue from 'vue'
import BaseTable from "@/components/ui/Table/Table.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
import DeleteButton from "@/components/ui/DeleteButton.vue";
import EditButton from "@/components/ui/EditButton.vue";
import Button from "@/components/ui/Button.vue";
import BaseModal from "@/components/ui/BaseModal.vue";
import DeletePartner from "@/views/partners/components/DeletePartner.vue";
import CashButton from "@/views/partners/components/CashButton.vue";
import ChangeBalanceLimit from "@/views/partners/components/ChangeBalanceLimit.vue";
import AddPartnerButton from "@/views/partners/components/AddPartnerButton.vue";
import BalanceTag from "@/views/partners/components/BalanceTag.vue";
import LimitTag from "@/views/partners/components/LimitTag.vue";
import BaseTag from "@/views/partners/components/BaseTag.vue";
import { getPartners, restorePerson, getLendingInfo } from "@/api/partner";
import TariffSettingsButton from "@/views/partners/components/TariffSettingsButton.vue";
import PartnerQrModal from "@/views/partners/components/PartnerQrModal.vue";
import PromoCodesButton from "@/views/partners/components/PromoCodesButton.vue";
import { userMixin } from "@/mixin";
import landingProductsMixin from '@/mixin/landingProductsMixin';

export default Vue.extend({
    name: "Index",
    mixins: [userMixin, landingProductsMixin],
    components: {
        PromoCodesButton,
        TariffSettingsButton,
        PartnerQrModal,
        BaseTag,
        LimitTag,
        BalanceTag,
        AddPartnerButton,
        ChangeBalanceLimit,
        CashButton,
        DeletePartner,
        BaseModal,
        Button,
        EditButton,
        DeleteButton,
        BaseTable,
        Breadcrumbs
    },
    data() {
        return {
            headers: {
                fullName: 'Імʼя',
                email: 'Email',
                phone: 'Телефон',
                balance: 'Баланс',
                limit: 'Ліміт',
                actions: ' '
            },
            partners: [],
            page: 1,
            total: 0,
            lastPage: 1,
            lendingBaseDomain: '',
            landingTenantBaseDomain: '',
            qrModalVisible: false,
            qrModalLink: '',
            qrModalLogo: '',
            qrModalBgColor: '',
        }
    },
    computed : {
        userTypes: function() {
          return this.$store.getters.USER_TYPES;
        },
        partnersList() {
            return this.partners.map(item => {
                const landingSetting = item.landingTenantSetting || null;
                const isLanding = Number(item.typeId) === this.getLandingTypeId();
                const subdomain = isLanding ? (landingSetting ? (landingSetting.slug || landingSetting.subdomain) : item.subdomain) : item.subdomain;
                const customDomain = isLanding ? (landingSetting ? (landingSetting.customDomain || landingSetting.custom_domain) : item.custom_domain) : item.custom_domain;
                const setupStatus = isLanding ? (landingSetting ? landingSetting.setupStatus : null) : item.setup_status;

                return {
                    id: item.id,
                    typeId: item.typeId,
                    fullName: item.fullName,
                    email: item.email,
                    phone: item.phone,
                    balance: item.currentMoneyScore,
                    limit: item.currentLimit,
                    setupStatus: setupStatus,
                    subdomain: subdomain,
                    custom_domain: customDomain,
                    logo_url: isLanding ? (landingSetting && landingSetting.settings ? landingSetting.settings.logo_url : null) : item.logo_url,
                    color: isLanding ? (landingSetting && landingSetting.settings ? landingSetting.settings.primary_color : null) : item.color,
                    qr_color: item.qr_color,
                }
            });
        },
        onlyTrashed() {
            return this.$route.query.onlyTrashed || false
        }
    },
    methods: {
        changeBreadcrumb(onlyTrashed) {
            if (onlyTrashed) {
                this.$route.meta.breadcrumb = 'Видалені точки продажу'
            } else {
                this.$route.meta.breadcrumb = 'Точки продажу'
            }
        },
        fetchPartnersList(page = 1, onlyTrashed = false) {
            getPartners({ page: page, onlyTrashed: onlyTrashed }).then(response => {
                this.partners = response.data.data;
                this.page = response.data.meta.current_page
                this.total = response.data.meta.total
                this.lastPage = response.data.meta.last_page
            });
        },
        changePage(page, onlyTrashed) {
            this.$router.push({name: 'partners', query: {page: page, onlyTrashed: onlyTrashed}})

            this.changeBreadcrumb(onlyTrashed);

            this.fetchPartnersList(page, onlyTrashed)
        },
        restorePartner(id) {
            this.$confirm('Відновити точку продажу?', 'Увага', {
                confirmButtonText: 'Так',
                cancelButtonText: 'Ні',
                type: 'warning'
            }).then(() => {
                restorePerson(id).then(response => {
                    this.$message.success(response.data.message);
                    this.fetchPartnersList(this.page, this.onlyTrashed)
                }).catch(error => {
                    this.$message.error(error.response.data.message);
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Скасовано'
                });
            });
        },
        copyWidgetCode(row, productPath = '/insurance/osago') {
            if (!row.subdomain && !row.custom_domain) {
                this.$message.error('Домен не знайдено');
                return;
            }

            let domain = '';
            const isLanding = row.typeId === this.getLandingTypeId();
            const embedPath = isLanding ? productPath + '/embed' : '/uk/sales-pipeline';
            if (row.custom_domain) {
                domain = `https://${row.custom_domain}${embedPath}`;
            } else {
                const baseDomain = isLanding ? this.landingTenantBaseDomain : this.lendingBaseDomain;
                domain = `https://${row.subdomain}.${baseDomain}${embedPath}`;
            }

            const iframeCode = `<iframe src="${domain}" width="100%" height="600" frameborder="0"></iframe>`;

            navigator.clipboard.writeText(iframeCode).then(() => {
                this.$message.success('Код віджета скопійовано в буфер обміну');
            }).catch(err => {
                this.$message.error('Не вдалося скопіювати код');
                console.error('Copy to clipboard failed:', err);
            });
        },
        /**
         * Публічна адреса сайту точки продажу (головна сторінка).
         * Для лендінгу продукт не обирається — перехід і QR ведуть на головну.
         */
        siteUrl(row) {
            if (row.custom_domain) {
                return `https://${row.custom_domain}`;
            }
            if (row.subdomain) {
                const isLanding = row.typeId === this.getLandingTypeId();
                const baseDomain = isLanding ? this.landingTenantBaseDomain : this.lendingBaseDomain;
                return `https://${row.subdomain}.${baseDomain}`;
            }
            return '';
        },
        openLanding(row) {
            const url = this.siteUrl(row);
            if (!url) {
                this.$message.error('Домен не знайдено');
                return;
            }
            window.open(url, '_blank');
        },
        openQrModal(row) {
            const url = this.siteUrl(row);
            if (!url) {
                this.$message.error('Домен не знайдено');
                return;
            }
            this.qrModalLink = url;
            this.qrModalLogo = row.logo_url || '';
            this.qrModalBgColor = row.qr_color || '#FFAD3D';
            this.qrModalVisible = true;
        }
    },
    mounted() {
        getLendingInfo().then(res => {
            if (res.data) {
                this.lendingBaseDomain = res.data.baseDomain || '';
                this.landingTenantBaseDomain = res.data.landingBaseDomain || res.data.baseDomain || '';
            }
        });
        this.fetchPartnersList(this.$route.query.page || 1, this.onlyTrashed)
    }
})
</script>

<template>
<div class="partners">
    <div class="position-relative">
        <div class="to-header">
            <AddPartnerButton/>
            <el-button v-if="!$route.query.onlyTrashed" @click="changePage(page, true)" type="danger">Видалені точки</el-button>
            <el-button v-else type="success" @click="changePage(page)">Точки продажу</el-button>
        </div>
    </div>

    <BaseTable
        v-if="partnersList"
        :data="partnersList"
        :headers="headers"
        :page="page"
        :last-page="lastPage"
        @change-page="changePage($event)"
    >
        <template #header-content>
            <div>
                Точки продажу
            </div>
            <BaseTag>{{ total }} менеджерів</BaseTag>
<!--            <Button>Видалені точки</Button>-->
        </template>
        <template #fullName="{ row }">
            <div class="name">
                {{ row.fullName }} <br>
                <span>#{{ row.id }}</span>
                <div v-if="row.typeId === getLendingPartnersTypeId() || row.typeId === getLandingTypeId()" style="margin-top: 4px; display: flex; align-items: center; gap: 8px;">
                    <template v-if="row.setupStatus === 'done' || (row.typeId === getLandingTypeId() && (row.subdomain || row.custom_domain))">
                        <!-- Widget Code -->
                        <el-dropdown trigger="click" @command="p => copyWidgetCode(row, p.path)" v-if="row.typeId === getLandingTypeId()">
                            <el-button type="primary" icon="el-icon-document-copy" size="mini" circle plain style="padding: 4px; border: none; background: transparent; color: #409EFF;" title="Скопіювати код віджета"></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="p in landingProducts" :key="'copy_'+p.key" :command="p" :disabled="p.disabled">{{ p.name }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-tooltip content="Скопіювати код віджета" placement="top" v-else>
                            <el-button type="primary" icon="el-icon-document-copy" size="mini" circle plain @click="copyWidgetCode(row)" style="padding: 4px; border: none; background: transparent; color: #409EFF;"></el-button>
                        </el-tooltip>

                        <!-- Open Site: для лендінгу — головна сторінка, без вибору продукту -->
                        <el-tooltip content="Відкрити сайт" placement="top">
                            <el-button type="success" icon="el-icon-link" size="mini" circle plain @click="openLanding(row)" style="padding: 4px; border: none; background: transparent; color: #67C23A;"></el-button>
                        </el-tooltip>

                        <!-- Generate QR: для лендінгу — головна сторінка, без вибору продукту -->
                        <el-tooltip content="Сформувати QR-код" placement="top">
                            <el-button type="warning" icon="el-icon-picture-outline" size="mini" circle plain @click="openQrModal(row)" style="padding: 4px; border: none; background: transparent; color: #E6A23C;"></el-button>
                        </el-tooltip>
                    </template>

                    <el-tag v-if="row.setupStatus === 'pending' || row.setupStatus === 'in_progress'" type="warning" size="mini">Налаштовується</el-tag>
                    <el-tag v-else-if="row.setupStatus === 'error'" type="danger" size="mini">Помилка налаштування</el-tag>
                    <el-tag v-else-if="row.setupStatus === 'done' || (row.typeId === getLandingTypeId() && (row.subdomain || row.custom_domain))" type="success" size="mini">Лендінг активний</el-tag>
                    <el-tag v-else type="info" size="mini">Лендінг не активний</el-tag>
                </div>
            </div>
        </template>
        <template #phone="{ value }">
            <div class="phone">{{ value }}</div>
        </template>
        <template #balance="{ value }">
            <BalanceTag>{{ value }}</BalanceTag>
        </template>
        <template #limit="{ value }">
            <LimitTag class="limit">{{ value || 0.00 }}</LimitTag>
        </template>
        <template #actions="{row}">
            <div class="d-flex gap-3" v-if="onlyTrashed">
                <el-button @click="restorePartner(row.id)" type="warning">Відновити точку продажу</el-button>
            </div>
            <div class="d-flex gap-3 align-items-center" v-else>
                <EditButton @click="$router.push({name: 'edit-partner', params: {id: row.id}})"/>
                <ChangeBalanceLimit :partner="row" @updated="fetchPartnersList"/>
                <TariffSettingsButton :id="row.id"></TariffSettingsButton>
                <PromoCodesButton v-if="row.typeId === getLandingTypeId()" :id="row.id"></PromoCodesButton>
                <DeletePartner :id="row.id" @deleted="fetchPartnersList(page, onlyTrashed)" />
            </div>
        </template>
    </BaseTable>

    <PartnerQrModal
        :visible.sync="qrModalVisible"
        :link="qrModalLink"
        :logo-url="qrModalLogo"
        :initial-bg-color="qrModalBgColor"
    />
</div>
</template>

<style scoped lang="scss">
.partners {
    .name {
        /* Text sm / Medium */
        font-family: Inter, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height, or 143% */

        /* Gray/900 */
        color: #181D27;


        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;
        span {
            font-family: 'Inter',serif;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #535862;
            flex: none;
            order: 1;
            flex-grow: 0;
        }
    }
    .phone {
        font-family: 'Geist',serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height, or 143% */

        /* Gray/600 */
        color: #535862;
        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;
    }
    .gap-3 {
        gap: 12px;
    }
    .to-header {
        display: flex;
        gap: 10px;
        position: unset;
        top: unset;
        right: unset;
        margin-bottom: 10px;
        @media (min-width: 768px) {
            position: absolute;
            top: -80px;
            right: 0;
        }
    }
}
</style>
